import { useState, useCallback, useEffect } from 'react';

import type { Provider, CollabEditProvider } from '@atlaskit/collab-provider';

export const useMetadataChanged = (
	collabEditProvider: (CollabEditProvider & Provider) | null,
	onMetadataChange?: () => void,
) => {
	const [title, setTitle] = useState<string | null>(null);
	const onTitleChange = useCallback(
		(newTitle: string) => {
			if (collabEditProvider) {
				setTitle(newTitle);
				const metadata = collabEditProvider.getMetadata();
				collabEditProvider.setMetadata({ ...metadata, metadataSource: 'client', title: newTitle });
			}
		},
		[collabEditProvider],
	);
	useEffect(() => {
		if (!collabEditProvider) {
			return;
		}
		const handleTitleChanged = (data) => {
			if (!data || !('title' in data)) {
				return;
			}
			const { title } = data;
			setTitle(title);
			onMetadataChange?.();
		};
		collabEditProvider.on('metadata:changed', handleTitleChanged);
		return () => {
			collabEditProvider.off('metadata:changed', handleTitleChanged);
		};
	}, [collabEditProvider, onMetadataChange]);

	return {
		onTitleChange,
		title,
	};
};
